import $http from "../../helpers/api";

const state = {
    forSale: [],
    inCart: [],
    inCartUsedParts: [],
    categories: [],
    all: []
};

const getters = {
    all: state => state.all,
    forSale: state => state.forSale,
    inCart: state => state.inCart,
    inCartUsedParts: state => state.inCartUsedParts,
    categories: state => state.categories,
    count: state => state.inCart.length
};

const mutations = {
    ADD_TO_CART(state, {
        product,
        inv
    }) {
        let war = inv === 0 ?
            1 :
            0;
        const record = state.inCart.find(function(p, i) {
            return p.part_id === product.id && p.inventory_type_id === inv;
        });

        if (!record) {
            state.inCart.push({
                name: product.name,
                sku: product.sku,
                part_id: product.id,
                quantity: 1,
                in_warranty: war,
                remove_from_stock: false,
                inventory_type_id: inv,
                unit_price: product.price,
                price: product.price * 1
            });
        } else {
            record.quantity++;
            record.price = product.price * record.quantity;
        }
    },
    REMOVE_FROM_CART(state, index) {
        state.inCart.splice(index, 1);
    },
    TOGGLE_REMOVE(state, index) {
        if (state.inCart[index].remove_from_stock) {
            state.inCart[index].remove_from_stock = false;
        } else {
            state.inCart[index].remove_from_stock = true;
        }
    },
    decreaseQuantity(state, index) {
        const qty = state.inCart[index].quantity;
        if (qty == 1) {
            state.inCart.splice(index, 1);
        } else {
            let itemprice = state.inCart[index].price / state.inCart[index].quantity;
            state.inCart[index].quantity--;
            state.inCart[index].price = itemprice * state.inCart[index].quantity;
        }
    },
    increaseQuantity(state, index) {
        let itemprice = state.inCart[index].price / state.inCart[index].quantity;
        state.inCart[index].quantity++;
        state.inCart[index].price = itemprice * state.inCart[index].quantity;
    },
    decreaseForSale(state, index) {
        let item = {};
        if (typeof index == "number") {
            item.product = state.inCart[index];
            item.product_id = state.inCart[index].part_id;
            item.inventory_type_id = state.inCart[index].inventory_type_id;
        } else {
            item.product = index.product;
            item.product_id = index.product.id;
            item.inventory_type_id = index.inv;
        }

        const record = state.forSale.find(p => {
            return p.id === item.product_id;
        });
        if (record) {
            record.inventories.forEach(e => {
                if (item.inventory_type_id === e.inventory_type_id) {
                    if (item.inventory_type_id != 3 || item.product.remove_from_stock) {
                        e.quantity--;
                    }
                }
            });
        }
    },
    increaseForSale(state, index) {
        let item = state.inCart[index];
        const record = state.forSale.find(p => {
            return p.id === item.part_id;
        });
        if (record) {
            record.inventories.forEach(e => {
                if (item.inventory_type_id === e.inventory_type_id) {
                    e.quantity++;
                }
            });
        }
    },
    addToForSale(state, index) {
        const item = state.inCart[index];
        const record = state.forSale.find(p => {
            return p.id === item.part_id;
        });
        if (record.inventories) {
            record.inventories.forEach(e => {
                if (item.inventory_type_id == e.inventory_type_id) {
                    e.quantity = e.quantity + item.quantity;
                }
            });
        }
    },
    setForSale(state, forSale) {
        state.forSale = forSale;
    },
    setCategories(state, categories) {
        state.categories = categories;
    },
    setAll(state, all) {
        state.all = all;
    },
    clearForSale(state) {
        state.forSale = [];
    },
    clearCart(state) {
        state.inCart = [];
    },
    setCart(state, cart) {
        state.inCart = cart;
    },
    setCartUsedParts(state, cart) { //marcel 2020-03-22
        state.inCartUsedParts = cart;
    },
    setPrice(state) {
        state.inCart.forEach(function(e) {
            e.price = e.in_warranty == 1 || e.inventory_type_id == 1 || e.inventory_type_id == 2 ?
                0 :
                e.unit_price * e.quantity;
        });
    },
    clearAll(state) {
        state.forSale = [];
        state.inCart = [];
        state.inCartUsedParts = [];
        state.categories = [];
        state.all = [];
    }
};

const actions = {
    addToCart({
        commit
    }, data) {
        commit("decreaseForSale", data);
        commit("ADD_TO_CART", data);
        commit("setPrice");
    },
    removeFromCart({
        state,
        commit
    }, index) {
        if (state.inCart[index].inventory_type_id != 3 || state.inCart[index].remove_from_stock) {
            commit("addToForSale", index);
        }
        commit("REMOVE_FROM_CART", index);
    },
    toggleRemove({
        state,
        commit
    }, index) {
        commit("TOGGLE_REMOVE", index);
        if (state.inCart[index].remove_from_stock) {
            commit("decreaseForSale", index);
        } else {
            commit("increaseForSale", index);
        }
    },
    decreaseQuantity({
        commit
    }, index) {
        commit("increaseForSale", index);
        commit("decreaseQuantity", index);
        commit("setPrice");
    },
    increaseQuantity({
        commit
    }, index) {
        commit("decreaseForSale", index);
        commit("increaseQuantity", index);
        commit("setPrice");
    },
    getAllCategories({
        commit
    }) {
        return new Promise((resolve, reject) => {
            $http.get("parts/categories").then(resp => {
                commit("setCategories", resp.data);
            });
        });
    },
    getAllPartsBy({
        commit,
        rootGetters
    }, cat) {
        return new Promise((resolve, reject) => {
            let vars = {};
            if (cat) {
                vars = {
                    params: {
                        includes: [
                            "categories", "inventories"
                        ],
                        filter_groups: [{
                            filters: [{
                                key: "categories",
                                value: cat,
                                operator: "eq"
                            }]
                        }]
                    }
                };
            } else {
                vars = {
                    params: {
                        includes: ["categories", "inventories"]
                    }
                };
            }

            $http.get("/parts", vars).then(resp => {
                commit("setForSale", resp.data.parts);
            });
            resolve();
        });
    },
    getAllParts({
        commit,
        rootGetters
    }, pagename, cat) {
        return new Promise((resolve, reject) => {
            $http.get("/parts", {
                params: {
                    includes: ["categories", "inventories"]
                }
            }).then(resp => {
                let list = [];
                let asfid = rootGetters["auth/getCurrentAsf"];
                list = resp.data.parts;

                // se for pagina repairs  mostrar somente
                if (pagename == "repairs_status" && asfid > 0) {
                    list = list.filter(function(el, index, object) {
                        if (el.inventories.length) {
                            var i = el.inventories.length;
                            while (i--) {
                                if (el.inventories[i].asf_id != asfid) {
                                    object[index].inventories.splice(i, 1);
                                }
                            }
                            if (el.inventories.length == 0) {
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return false;
                        }
                    });
                }

                //filter part by user and page;
                let roles = rootGetters["auth/getSessionRoles"];

                list = list.filter(item => {
                    let test = false;
                    roles.forEach(r => {
                        let role = r.replace("-", "_");

                        // ajuste para permissoes iguais para todos os usuarios asf
                        if (role.includes("admin")) {
                            role = "admin";
                        }

                        if (item.visible && item.visible.user && item.visible.user[role] !== undefined) {
                            test = item.visible.user[role].checked;
                        }
                    });
                    return test;
                });

                list = list.filter(item => {
                    let test = false;
                    roles.forEach(r => {
                        let role = r.replace("-", "_");

                        // ajuste para permissoes iguais para todos os usuarios asf
                        if (role.includes("asf")) {
                            role = "asf";
                        }

                        if (item.visible && item.visible.user && item.visible.user[role] && item.visible.user[role].page && item.visible.user[role].page[pagename] && item.visible.user[role].page[pagename].checked !== undefined) {
                            test = item.visible.user[role].page[pagename].checked;
                        }
                    });
                    return test;
                });

                commit("setForSale", list);
                commit("setAll", list);
            });
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
